import { useEffect } from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";

export const Kontak = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="w-full min-h-screen py-20 text-center text-gray-900 flex-col justify-center relative bg-white">
      <div className="container mx-auto px-4">
        
        <div className="max-w-6xl mx-auto space-y-4">
          <motion.div
            className="text-left"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <div className="bg-white rounded-2xl px-4 py-6 border border-slate-200">
              <div className="space-y-4">
                {/* Email */}
                <motion.div
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: 0.4 }}
                  viewport={{ once: true }}
                >
                  <div className="flex items-start">
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      className="w-4 h-4 text-slate-500 mt-1 mr-2"
                    />
                    <div>
                      <p className="text-md text-slate-700 font-bold">Email</p>
                      <a
                        href="mailto:admin@cakrawalajakarta.id"
                        className="text-lg text-slate-800 hover:underline"
                      >
                        admin@cakrawalajakarta.id
                      </a>
                    </div>
                  </div>
                </motion.div>

                {/* WhatsApp / Phone */}
                <motion.div
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: 0.5 }}
                  viewport={{ once: true }}
                >
                  <div className="flex items-start">
                    <FontAwesomeIcon
                      icon={faPhone}
                      className="w-4 h-4 text-slate-500 mt-1 mr-2"
                    />
                    <div>
                      <p className="text-md text-slate-700 font-bold">Phone</p>
                      <a
                        href="https://wa.me/628132020592"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-lg text-slate-800 hover:underline"
                      >
                        08132020592
                      </a>
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
          </motion.div>

          {/* Location Map Section */}
          <motion.div
            className="text-left"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <div className="bg-white rounded-2xl px-4 py-6 border border-slate-200">
              <div className="flex items-center gap-3 mb-4">
                <FontAwesomeIcon
                  icon={faMapMarkerAlt}
                  className="text-2xl text-slate-500"
                />
                <div>
                  <h3 className="text-xl font-bold text-slate-700">
                    Location
                  </h3>
                  <p className="text-sm text-gray-600">
                    Indomilk Arena Stadium
                  </p>
                </div>
              </div>

              <div className="w-full h-[400px] rounded-xl overflow-hidden shadow-sm border border-gray-100 mb-4">
                <iframe 
                  src="https://maps.google.com/maps?q=Indomilk+Arena+Stadium+Tangerang+Banten&output=embed&z=15"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Indomilk Arena Stadium Map"
                ></iframe>
              </div>

              <div className="space-y-1">
                <p className="text-lg font-bold text-gray-900">
                  Indomilk Arena Stadium
                </p>
                <p className="text-md text-gray-600">
                  Tangerang, Banten · Indonesia
                </p>
                <p className="text-sm text-gray-600 italic">
                  Professional athletics track with international standards
                </p>
              </div>
              
              <div className="mt-4">
                <a
                  href="https://www.google.com/maps/search/Indomilk+Arena+Stadium+Tangerang+Banten"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block text-gray-900 font-semibold hover:text-gray-700 hover:underline"
                >
                  View on Google Maps &rarr;
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};